import React from 'react';
import { Bell, Mail } from 'lucide-react';
import { Section, ToggleRow } from '../workersetting/settinghelper/SettingsHelpers';

const NotificationsSection = ({
  push_notifications,
  setPush_notifications,
  email_notifications,
  setEmail_notifications,
  availablity,
  updateSetting
}) => {
  return (
    <Section title="NOTIFICATIONS">

      <ToggleRow
        icon={<Bell size={20} />}
        iconColor="#0491e1"
        iconBg="#e8f4fd"
        title="Push Notifications"
        subtitle="Receive push notifications"
        checked={push_notifications}
        onToggle={(value) => {
          setPush_notifications(value);
          updateSetting(value, email_notifications, availablity);
        }}
      />

      <ToggleRow
        icon={<Mail size={20} />}
        iconColor="#8b5cf6"
        iconBg="#f3f0ff"
        title="Email Notifications"
        subtitle="Receive email updates"
        checked={email_notifications}
        onToggle={(value) => {
          setEmail_notifications(value);
          updateSetting(push_notifications, value, availablity);
        }}
      />

    </Section>
  );
};

export default NotificationsSection;